module.exports = __webpack_public_path__ + "img/academy-bg-certified-cards.2483272.png";